module.exports = __webpack_public_path__ + "img/artubeleague_event.fcc16fd4.jpg";